import React from 'react';
import ReaderForm from './components/ReaderForm';

const ReaderCreatePage: React.FC = () => {
  // Title is set at the application level
  return <ReaderForm isEdit={false} />;
};

export default ReaderCreatePage;